// STATE: Minimum of 5% & maximum of 10% bonds up to $1,000 penal liability; 
//        $50 per bond mininimum. 
//        Minimum of 5% & maximum of 10% bonds over $1,000 penal liability.           

// IMMIGRATION: 15% of the penal amount. $100 mimimum. The premium will be charged and collected on an annual basis untill the surety is legally dischared form all liability on the bonds(s

/* eslint-disable */
export const equation = ({ bondValue, premium, type, additional }) => {
  let value = null
  let condition = null
  let minimum = 0
  let calcMinimum = (bondValue * .05)
  if (type === 'STATE') {
    if (bondValue <= 1000) {
      value = (bondValue * .1)
      if (value < 50) {
        value = 50
        condition = 'Minimum not met'
      }
    } else {
      value = (bondValue * .1)
    }
  }
  return { value, minimum: calcMinimum, condition }
}
/* eslint-enable */

export default equation